import * as React from 'react';
import { SubmissionState, UploadState } from '../../interface/SubmissionInterface';
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface DataProcessingStepProps {
    step?: string;

    heading?: string;
    tooltip?: string;

    csvData?: any;

    downloadCSVFile(csvData,fileType, display_id, submission_id);
}

export class DataProcessingStep extends React.Component<DataProcessingStepProps & SubmissionState & UploadState, {}> {
    render() {
        var count, percent, dollars, max_length;
        var text1, text2, text3;

        if ((this.props.step == "dupes" && this.props.DupesSummaryOutput !== undefined)
            || (this.props.step == "dupes_b" && this.props.DupesSummaryOutput_b !== undefined)
            || (this.props.step == "abv" && this.props.AbvOutput !== undefined && this.props.AbvOutput.abvSummaryOutput !== undefined)
            || (this.props.step == "fix_spending" && this.props.FixSpendingOutput !== undefined && this.props.FixSpendingOutput.fixSpendingSummaryOutput !== undefined)
            || (this.props.step == "truncation" && this.props.TruncationOutput !== undefined && this.props.TruncationOutput.truncationSummaryOutput !== undefined)) {

            if (this.props.step == "dupes") {
                count = this.props.DupesSummaryOutput.dupe_count;
                percent = (this.props.DupesSummaryOutput.pct_rows_duplicated * 100).toFixed(0);
                dollars = "$"+this.props.DupesSummaryOutput.dollars_affected;

                text1 = "No. of duplicates:";
                text2 = "Percentage of file affected:";
                text3 = "Dollars affected:";
            }
            else if (this.props.step == "dupes_b") {
                count = this.props.DupesSummaryOutput_b.dupe_count;
                percent = (this.props.DupesSummaryOutput_b.pct_rows_duplicated * 100).toFixed(0);
                dollars = "$" +this.props.DupesSummaryOutput_b.dollars_affected;

                text1 = "No. of duplicates:";
                text2 = "Percentage of file affected:";
                text3 = "Dollars affected:";
            }
            else if (this.props.step == "abv") {
                count = this.props.AbvOutput.abvSummaryOutput.abv_count;
                percent = (this.props.AbvOutput.abvSummaryOutput.pct_file_affected * 100).toFixed(0);
                dollars = "$" +this.props.AbvOutput.abvSummaryOutput.payment_affected;

                text1 = "No. of records:";
                text2 = "Percentage of file affected:";
                text3 = "Dollars affected:";
            }
            else if (this.props.step == "fix_spending") {
                count = this.props.FixSpendingOutput.fixSpendingSummaryOutput.unrecognized_row_count;
                percent = (this.props.FixSpendingOutput.fixSpendingSummaryOutput.pct_changed * 100).toFixed(0);
                dollars = this.props.FixSpendingOutput.fixSpendingSummaryOutput.cleaned_row_count;

                text1 = "No. of unrecognized rows:";
                text2 = "Percentage of file changed:";
                text3 = "No. of cleaned rows:";
            }
            else if (this.props.step == "truncation") {
                count = this.props.TruncationOutput.truncationSummaryOutput.maximum_affected_rows;
                percent = (this.props.TruncationOutput.truncationSummaryOutput.pct_rows_affected * 100).toFixed(0);
                dollars = this.props.TruncationOutput.truncationSummaryOutput.maximum_affected_spending;
                max_length = this.props.TruncationOutput.truncationSummaryOutput.max_length;

                text1 = "No. of records:";
                text2 = "Percentage of file affected:";
                text3 = "Dollars affected:";
                var text4 = "Max field length:";
            }

            return <div className="inner-wrap">
                <p className="steps">{this.props.heading}
                    <OverlayTrigger placement="bottom" overlay={this.getTooltip(this.props.tooltip)}>
                        <span className='help'><i className="fa fa-info-circle fa-lg"></i></span>
                    </OverlayTrigger>
                </p>
                <p>{text1}<span className="result">{count}</span></p>
                <p>{text2}<span className="result">{percent}%</span></p>
                <p>{text3}<span className="result">{dollars}</span></p>
                {text4 && <p>{ text4 }<span className="result">{max_length}</span></p>}
                <span className="icon-input-btn"><span className="glyphicon glyphicon-save"></span>

                <input type="button" onClick={() => this.props.downloadCSVFile(this.props.csvData,this.props.fileType, this.props.UserState.display_id, this.props.SubmissionState.SubmissionID)} className="step_download btn btn-primary" id="download_btn_1a" name="download_btn_1a" value="Download" /></span>
            </div>
        }
    else {
            return <div className="inner-wrap">
                <p className="steps">{this.props.heading}
                    <OverlayTrigger placement="bottom" overlay={this.getTooltip(this.props.tooltip)}>
                        <span className='help'><i className="fa fa-info-circle fa-lg"></i></span>
                    </OverlayTrigger>
                </p>
                loading.. <i className="fa fa-spinner"></i>
            </div>
        }
    }

    getTooltip(tooltipContent) {
        return (
            <Tooltip id="tooltip">
                <p>{tooltipContent}</p>
            </Tooltip>
        )
    }
}